<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :column="column" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div>
      <div class="row ticketlistheader">
        <div class="col-md-12">
          <div class="input-group">
            <input type="text" class="form-control" :placeholder="searchHint" v-model="searchStr" />
            <div class="input-group-btn">
              <Dropdown buttonClass="btn-default" menuClass="dropdown-menu-right">
                <template #trigger>
                  {{ chooseTitle }} &nbsp;<span class="caret"></span>
                </template>
                <li v-for="ts in possibleDates"><a href="javascript:;" v-on:click="selectDate(ts)">{{ groupTitle(ts) }}</a></li>
                <li class="divider"></li>
                <li><a href="javascript:;" v-on:click="showModal"><i class="fa fa-fw fa-calendar"></i> {{ _('Exact date') }}</a></li>
              </Dropdown>
            </div>
            <span class="input-group-btn">
              <button type="button" class="btn btn-default" v-on:click="clearSearch"><i class="fa fa-fw fa-times"></i></button>
            </span>
          </div>
        </div>
      </div>
      <div class="ticketlistgroup activityticketlistgroup">
        <template v-for="(items, ts) in groupedShowsFiltered">
          <div class="row daytitle-row">
            <h4 class="daytitle col-md-12">{{ groupTitle(ts) }}</h4>
          </div>
          <div class="card-items activity-card-items">
            <ticket-activity-item v-for="item in items" :key="item.id" :item="item" v-on:itemClicked="buyTicketClicked" v-on:openDatePicker="showModal"></ticket-activity-item>
          </div>
        </template>
      </div>
    </div>
    <modal :name="modalId" :adaptive="true" :width="300" :maxWidth="300" :maxHeight="300" :scrollable="true" height="auto">
      <div class="product-order-wrap">
        <div class="container product-order-container" style="height: 120px">
          <div class="row">
            <div class="col-md-12 col-p-8 product-order-options">
              <DatePicker field="custom" :title="_('Date')" :shortLocale="shortLocale" v-on:update:modelValue="dateSelected"></DatePicker>
            </div>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>
<style>
.ticketlistgroup {
  border-bottom: 1px #ECEFF1 solid;
}
.daytitle {
  color: #78909C;
}
</style>

<script>
  
import axios from 'axios'
import TicketActivityItem from '~/components/TicketActivityItem'
import components from '~/lib/components'
import { DateTime } from 'luxon'
import seatmap from '~/lib/seatmap'
import debounce from 'lodash/debounce'
import throttle from 'lodash/throttle'
import DatePicker from '~/components/DatePicker.vue'

export default {
  data () {
    return {
      resourcepoolId: null,
      shows: [],
      groupedShows: {},
      selectedSeats: [],
      activeShow: false,
      searchStr: '',
      selectedDate: null,
      customDate: null,
      showDateFormat: 'yyyy-MM-dd H:mm'
    }
  },
  mixins: [components],
  computed: {
    searchHint () {
      return this._('Search by name')
    },
    clientId () {
      return this.$store.state.clientid
    },
    modalId () {
      return this.column.identifier + '-component-' + this.component.id + '-datepicker'
    },
    data () {
      return (this.component.data !== '' ? JSON.parse(this.component.data) : false)
    },
    productCount () {
      return 1
    },
    resourceCount () {
      return 1
    },
    reservationCount () {
      return this.selectedSeats.length
    },
    chooseTitle () {
      if (this.customDate) {
        return this.groupTitle(DateTime.fromJSDate(this.customDate).toUnixInteger())
      }
      if (this.selectedDate) {
        return this.groupTitle(this.selectedDate)
      }
      return this._('Choose a date')
    },
    possibleDates () {
      let dates = []
      for (var ts in this.groupedShows) {
        if (Object.prototype.hasOwnProperty.call(this.groupedShows, ts)) {
          dates.push(ts)
        }
      }
      return dates
    },
    groupedShowsFiltered () {
      if (!this.searchStr && !this.selectedDate) {
        return this.groupedShows
      }
      let filtered = {}
      for (var ts in this.groupedShows) {
        if (Object.prototype.hasOwnProperty.call(this.groupedShows, ts)) {
          filtered[ts] = []
          for (var i = 0; i < this.groupedShows[ts].length; i++) {
            let show = this.groupedShows[ts][i]
            if (!this.searchStr ||
                show.text.match(new RegExp(this.searchStr, 'i')) ||
                show.agelimit === this.searchStr.toUpperCase() || 
                (show.attributes && show.attributes[this.searchStr.toLowerCase()])) {
              if (!this.selectedDate || this.selectedDate === ts) {
                filtered[ts].push(show)
              }
            }
          }
          if (!filtered[ts].length) {
            delete filtered[ts]
          }
        }
      }
      return filtered
    },
    shortLocale () {
      return this.locale.split('_')[0]
    }
  },
  methods: {
    getActivePricingIndex(data) {
      let activeIndex = 0
      if (
        data &&
        data.selectedlength &&
        data.selectedunittype
      ) {
        for (let i = 0; i < data.prices.detail.length; i++) {
          if (
            parseInt(data.prices.detail[i].unit, 10) ===
              parseInt(data.selectedlength, 10) &&
            parseInt(data.prices.detail[i].unittype, 10) ===
              parseInt(data.selectedunittype, 10)
          ) {
            activeIndex = i
          }
        }
      }
      return activeIndex
    },
    getSelectedTicketPricing (pricingIndex, data) {
      if (!pricingIndex || !(data && data.prices && data.prices.detail)) {
        return 0
      }
      return data.prices.detail[pricingIndex].pricing
    },
    showModal () {
      this.$modal.show(this.modalId)
    },
    hideModal () {
      this.$modal.hide(this.modalId)
    },
    dateSelected (d) {
      this.hideModal()
      this.loadCustomDate(d)
    },
    selectDate (ts) {
      this.selectedDate = ts
    },
    clearSearch () {
      this.searchStr = ''
      this.selectedDate = null
      if (this.customDate) {
        this.customDate = null
        this.loadTicketActivities()
      }
    },
    loadTicketActivities () {
      let $this = this
      let d = new Date()
      let past = false
      if (this.customDate) {
        d = this.customDate
        past = true
      }
      let yy = d.getFullYear()
      let mm = d.getMonth() + 1
      let dd = d.getDate()
      if (mm < 10) {
        mm = '0' + mm
      }
      if (dd < 10) {
        dd = '0' + dd
      }
      let resourcepoolStr = ''
      if (this.data && this.data.resourcepoolId !== null) {
        this.resourcepoolId = this.data.resourcepoolId
        resourcepoolStr += '&resourcepool=' + this.data.resourcepoolId
      } 
      let fromStr = yy + '-' + mm + '-' + dd
      axios.get(this.baseDomain + this.shopId + '/ticketschedule.json?from=' + fromStr + '&pos=true&details=true' + (past ? '&past=true&days=1' : '') + '&version=' + this.version + '&apikey=' + this.apiKey + resourcepoolStr)
      .then(response => {
        this.shows = response.data.data
        this.groupTicketActivitiesByDate(response.data.data)
      })
      .catch(function (e) {
        console.log('Failed to load transactions.')
      })
    },
    throttledReload: throttle(function () { this.loadTicketActivities() }, 1000, { leading: false, trailing: true }),
    groupTicketActivitiesByDate (shows) {
      this.groupedShows = {}
      for (var i = 0; i < shows.length; i++) {
        let currTs = DateTime.fromFormat(shows[i].start_date, this.showDateFormat).startOf('day').toUnixInteger()
        if (!this.groupedShows[currTs]) {
          this.groupedShows[currTs] = []
        }
        this.groupedShows[currTs].push(shows[i])
      }
    },
    groupTitle (ts) {
      return this._(DateTime.fromSeconds(Number(ts), { zone: this.timezone }).toFormat('cccc')) + ' ' + DateTime.fromSeconds(Number(ts), { zone: this.timezone }).toFormat(this.dateFormat)
    },
    // Sorry but these are pretty much copy pasted from ReservableProductListItem.vue @todo refactor into some separate thingy perhaps
    buyTicketClicked (item) {
      let numSeats = null
      if (arguments.length > 1) {
        numSeats = parseInt(arguments[1])
      }
      this.addActivityItemToBasket(item, numSeats)
      /*
      axios.get(`${this.baseDomain}${this.shopId}/${this.locale}/shows/${show.id}.json?details=true&pos=true`)
      .then(response => {
        show = response.data
        // if we don't have seat selection, add it to basket directly
        if (!parseInt(show.showseatmap)) {
          this.addShowToBasket(show, numSeats)
        } else {
          // otherwise open seatmap
          this.seatMap = null
          this.openSeatMap(show, false, this.shopId)
        }
      })
      */
    },
    async addActivityItemToBasket (item, numSeats) {
      let $this = this
      let mode = 'hours'
      item.product.currency = this.shopSettings(this.shopId).currency
      let data = {
        version: this.version,
        locale: this.locale,
        product: item.product,
        shopId: this.shopId,
        count: this.productCount,
        resourceCount: this.resourceCount,
        reservationCount: numSeats ? numSeats : this.reservationCount,
        reservationDateStart: DateTime.fromFormat(item.start_date, this.showDateFormat).toFormat('d.M.yyyy'),
        reservationTimeStart: DateTime.fromFormat(item.start_date, this.showDateFormat).toFormat('H.mm'),
        reservationTimeEnd: DateTime.fromFormat(item.end_date, this.showDateFormat).toFormat('H.mm')
      }
      if (DateTime.fromFormat(item.start_date, this.showDateFormat).toFormat('d.M.yyyy') !== DateTime.fromFormat(item.end_date, this.showDateFormat).toFormat('d.M.yyyy')) {
        data.reservationDateEnd = DateTime.fromFormat(item.end_date, this.showDateFormat).toFormat('d.M.yyyy')
      }
      /*
      if (this.selectedSeats.length) {
        data.selectedSeats = this.selectedSeats.join(',')
      }
      */
      let priceResponse = await axios.get(this.baseDomain + this.shopId + '/' + this.locale + '/products/' + data.product.id + '/fullprices.json?date=' + DateTime.fromFormat(item.start_date, this.showDateFormat).toUnixInteger() + '&starttime=' + data.reservationTimeStart + '&endtime=' + data.reservationTimeEnd + '&mode=' + mode + '&resource_count=' + data.resourceCount + '&reservation_count=' + data.reservationCount + '&client=' + this.clientId)  
      let currentPricingIndex = this.getActivePricingIndex(priceResponse.data)

      if (!priceResponse || !priceResponse.data || !priceResponse.data.prices || !priceResponse.data.prices.detail || !priceResponse.data.prices.detail[currentPricingIndex] || !priceResponse.data.prices.detail[currentPricingIndex].tickets) {
        this.showAddedToBasketError()
        return
      }

      for (let j = 0; j < priceResponse.data.prices.detail[currentPricingIndex].tickets.length; j++) {
        let ticket = priceResponse.data.prices.detail[currentPricingIndex].tickets[j]
        if (parseInt(ticket.default)) {
          data.ticket = ticket.id
        }
      }

      if (!data.ticket) {
        this.showAddedToBasketError()
        return
      }
      data.pricing = priceResponse.data.prices.detail[currentPricingIndex].pricing
      this.$store.dispatch('addToBasket', data)
      .then(function () {
        $this.showAddedToBasketNotification($this.$filters.marketingname(item.product))
      })
      .catch(function (err) {
        $this.showAddedToBasketError(err)
      })
    },
    getDMY (d) {
      return d.getDate() + '.' + (d.getMonth() + 1) + '.' + d.getFullYear()
    },
    getYMD (d) {
      return d.getFullYear() + '-' + (d.getMonth() + 1 < 10 ? '0' : '') + (d.getMonth() + 1) + '-' + (d.getDate() < 10 ? '0' : '') + d.getDate()
    },
    getHM (d) {
      return d.getHours() + '.' + (d.getMinutes() < 10 ? '0' : '') + d.getMinutes()
    },
    loadCustomDate (d) {
      this.customDate = d
      this.loadTicketActivities()
    }
  },
  components: {
    TicketActivityItem,
    DatePicker
  },
  updated () {
    if (this.data && this.resourcepoolId !== this.data.resourcepoolId) {
      this.loadTicketActivities()
    }
  },
  watch: {
    version () {
      this.loadTicketActivities()
    }
  },
  mounted () {
    this.loadTicketActivities()
    if(!this.events) {
      let events = {}
      events['showUpdate'] = (message) => {
        if (this.shopId == message.shopId) {
          return this.throttledReload()
        }
      }
      events['productUpdate'] = (message) => {
        for (var i = 0; i < this.shows.length; i++) {
          let show = this.shows[i]
          if (this.shopId == message.shopId && show.product_id == message.data.id) {
            return this.throttledReload()
          }
        }
      }
      events['resourceUpdate'] = (message) => {
        for (var i = 0; i < this.shows.length; i++) {
          let show = this.shows[i]
          if (this.shopId == message.shopId && show.resource_id == message.data.id) {
            return this.throttledReload()
          }
        }
      }
      events['availabilityUpdate'] = (message) => {
        let $this = this
        if (message.shopId != this.$store.state.shopId) {
          return
        }
        this.throttledReload()
        if (!this.activeShow) {
          return
        }
      }
      this.events = events
    }
    this.enableEventBus()
  }
}

</script>

<style scoped>
.ticketlistheader {
  margin-top: 15px;
}
</style>